'use es6';

import { requestStates } from 'redux-request-state';
import createRequestStatesReducer from 'ContentEditorUI/redux/reducers/createRequestStatesReducer';
import { CREATE_POST_TAG_REQUEST, CREATE_POST_TAG_TRANSLATION_REQUEST, FETCH_POST_TAGS_REQUEST, FETCH_POST_AVAILABLE_AUTHORS_REQUEST, FETCH_POST_NOTIFICATIONS_EMAILS_REQUEST, FETCH_POST_SOCIAL_ACCOUNTS_REQUEST, FETCH_POST_SOCIAL_AUTO_PUBLISHING_REQUEST, FETCH_SOCIAL_AUTO_PUBLISH_STATUS_REQUEST, FETCH_SOCIAL_BROADCASTS_REQUEST, FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_REQUEST, FETCH_POST_BLOGS_REQUEST, FETCH_BLOG_LIMIT_REQUEST, FETCH_BLOG_POST_LIMIT_REQUEST, FETCH_MLANG_BLOG_POST_LIMIT_REQUEST, FETCH_BLOG_LISTING_PAGES_REQUEST } from '../../Constants';
import * as actionTypes from '../actions/actionTypes';
const {
  FAILED,
  STARTED,
  SUCCEEDED
} = requestStates;
const fetchPostTagsArtifactBuilders = {
  [actionTypes.FETCH_POST_TAGS_STARTED]: () => ({
    requestKey: FETCH_POST_TAGS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_POST_TAGS_SUCCEEDED]: () => ({
    requestKey: FETCH_POST_TAGS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_POST_TAGS_FAILED]: () => ({
    requestKey: FETCH_POST_TAGS_REQUEST,
    requestState: FAILED
  })
};
const createPostTagArtifactBuilders = {
  [actionTypes.CREATE_POST_TAG_STARTED]: () => ({
    requestKey: CREATE_POST_TAG_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.CREATE_POST_TAG_SUCCEEDED]: () => ({
    requestKey: CREATE_POST_TAG_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.CREATE_POST_TAG_FAILED]: () => ({
    requestKey: CREATE_POST_TAG_REQUEST,
    requestState: FAILED
  })
};
const createPostTagTranslationArtifactBuilders = {
  [actionTypes.CREATE_POST_TAG_TRANSLATION_STARTED]: () => ({
    requestKey: CREATE_POST_TAG_TRANSLATION_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.CREATE_POST_TAG_TRANSLATION_SUCCEEDED]: () => ({
    requestKey: CREATE_POST_TAG_TRANSLATION_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.CREATE_POST_TAG_TRANSLATION_FAILED]: () => ({
    requestKey: CREATE_POST_TAG_TRANSLATION_REQUEST,
    requestState: FAILED
  })
};
const fetchFeaturedImageThumbnailUrlsArtifactBuilders = {
  [actionTypes.FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_STARTED]: () => ({
    requestKey: FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_SUCCEEDED]: () => ({
    requestKey: FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_FAILED]: () => ({
    requestKey: FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_REQUEST,
    requestState: FAILED
  })
};
const fetchNotificationEmailsArtifactBuilders = {
  [actionTypes.FETCH_POST_NOTIFICATIONS_EMAILS_STARTED]: () => ({
    requestKey: FETCH_POST_NOTIFICATIONS_EMAILS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_POST_NOTIFICATIONS_EMAILS_SUCCEEDED]: () => ({
    requestKey: FETCH_POST_NOTIFICATIONS_EMAILS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_POST_NOTIFICATIONS_EMAILS_FAILED]: () => ({
    requestKey: FETCH_POST_NOTIFICATIONS_EMAILS_REQUEST,
    requestState: FAILED
  })
};
const fetchPostAvailableAuthorsArtifactBuilders = {
  [actionTypes.FETCH_POST_AVAILABLE_AUTHORS_STARTED]: () => ({
    requestKey: FETCH_POST_AVAILABLE_AUTHORS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_POST_AVAILABLE_AUTHORS_SUCCEEDED]: () => ({
    requestKey: FETCH_POST_AVAILABLE_AUTHORS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_POST_AVAILABLE_AUTHORS_FAILED]: () => ({
    requestKey: FETCH_POST_AVAILABLE_AUTHORS_REQUEST,
    requestState: FAILED
  })
};
const fetchSocialAccountsArtifactBuilders = {
  [actionTypes.FETCH_POST_SOCIAL_ACCOUNTS_STARTED]: () => ({
    requestKey: FETCH_POST_SOCIAL_ACCOUNTS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_POST_SOCIAL_ACCOUNTS_SUCCEEDED]: () => ({
    requestKey: FETCH_POST_SOCIAL_ACCOUNTS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_POST_SOCIAL_ACCOUNTS_FAILED]: () => ({
    requestKey: FETCH_POST_SOCIAL_ACCOUNTS_REQUEST,
    requestState: FAILED
  })
};
const fetchSocialAutoPublishingArtifactBuilders = {
  [actionTypes.FETCH_POST_SOCIAL_AUTO_PUBLISHING_STARTED]: () => ({
    requestKey: FETCH_POST_SOCIAL_AUTO_PUBLISHING_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_POST_SOCIAL_AUTO_PUBLISHING_SUCCEEDED]: () => ({
    requestKey: FETCH_POST_SOCIAL_AUTO_PUBLISHING_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_POST_SOCIAL_AUTO_PUBLISHING_FAILED]: () => ({
    requestKey: FETCH_POST_SOCIAL_AUTO_PUBLISHING_REQUEST,
    requestState: FAILED
  })
};
const fetchSocialAutoPublishStatusArtifactBuilders = {
  [actionTypes.FETCH_SOCIAL_AUTO_PUBLISH_STATUS_STARTED]: () => ({
    requestKey: FETCH_SOCIAL_AUTO_PUBLISH_STATUS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_SOCIAL_AUTO_PUBLISH_STATUS_SUCCEEDED]: () => ({
    requestKey: FETCH_SOCIAL_AUTO_PUBLISH_STATUS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_SOCIAL_AUTO_PUBLISH_STATUS_FAILED]: () => ({
    requestKey: FETCH_SOCIAL_AUTO_PUBLISH_STATUS_REQUEST,
    requestState: FAILED
  })
};
const fetchSocialBroadcastsArtifactBuilders = {
  [actionTypes.FETCH_SOCIAL_BROADCASTS_STARTED]: () => ({
    requestKey: FETCH_SOCIAL_BROADCASTS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_SOCIAL_BROADCASTS_SUCCEEDED]: () => ({
    requestKey: FETCH_SOCIAL_BROADCASTS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_SOCIAL_BROADCASTS_FAILED]: () => ({
    requestKey: FETCH_SOCIAL_BROADCASTS_REQUEST,
    requestState: FAILED
  })
};
const fetchPostBlogsArtifactBuilders = {
  [actionTypes.FETCH_POST_BLOGS_STARTED]: () => ({
    requestKey: FETCH_POST_BLOGS_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_POST_BLOGS_SUCCEEDED]: () => ({
    requestKey: FETCH_POST_BLOGS_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_POST_BLOGS_FAILED]: () => ({
    requestKey: FETCH_POST_BLOGS_REQUEST,
    requestState: FAILED
  })
};
const fetchBlogLimitArtifactBuilders = {
  [actionTypes.FETCH_BLOG_LIMIT_STARTED]: () => ({
    requestKey: FETCH_BLOG_LIMIT_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_BLOG_LIMIT_SUCCEEDED]: () => ({
    requestKey: FETCH_BLOG_LIMIT_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_BLOG_LIMIT_FAILED]: () => ({
    requestKey: FETCH_BLOG_LIMIT_REQUEST,
    requestState: FAILED
  })
};
const fetchBlogPostLimitArtifactBuilders = {
  [actionTypes.FETCH_BLOG_POST_LIMIT_STARTED]: () => ({
    requestKey: FETCH_BLOG_POST_LIMIT_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_BLOG_POST_LIMIT_SUCCEEDED]: () => ({
    requestKey: FETCH_BLOG_POST_LIMIT_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_BLOG_POST_LIMIT_FAILED]: () => ({
    requestKey: FETCH_BLOG_POST_LIMIT_REQUEST,
    requestState: FAILED
  })
};
const fetchMlangBlogPostLimitArtifactBuilders = {
  [actionTypes.FETCH_MLANG_BLOG_POST_LIMIT_STARTED]: () => ({
    requestKey: FETCH_MLANG_BLOG_POST_LIMIT_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_MLANG_BLOG_POST_LIMIT_SUCCEEDED]: () => ({
    requestKey: FETCH_MLANG_BLOG_POST_LIMIT_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_MLANG_BLOG_POST_LIMIT_FAILED]: () => ({
    requestKey: FETCH_MLANG_BLOG_POST_LIMIT_REQUEST,
    requestState: FAILED
  })
};
const fetchBlogListingPagesArtifactBuilders = {
  [actionTypes.FETCH_BLOG_LISTING_PAGES_STARTED]: () => ({
    requestKey: FETCH_BLOG_LISTING_PAGES_REQUEST,
    requestState: STARTED
  }),
  [actionTypes.FETCH_BLOG_LISTING_PAGES_SUCCEEDED]: () => ({
    requestKey: FETCH_BLOG_LISTING_PAGES_REQUEST,
    requestState: SUCCEEDED
  }),
  [actionTypes.FETCH_BLOG_LISTING_PAGES_FAILED]: () => ({
    requestKey: FETCH_BLOG_LISTING_PAGES_REQUEST,
    requestState: FAILED
  })
};
const postArtifactBuilderLookup = Object.assign({}, createPostTagArtifactBuilders, createPostTagTranslationArtifactBuilders, fetchPostTagsArtifactBuilders, fetchFeaturedImageThumbnailUrlsArtifactBuilders, fetchNotificationEmailsArtifactBuilders, fetchPostAvailableAuthorsArtifactBuilders, fetchSocialAccountsArtifactBuilders, fetchSocialAutoPublishingArtifactBuilders, fetchSocialAutoPublishStatusArtifactBuilders, fetchSocialBroadcastsArtifactBuilders, fetchPostBlogsArtifactBuilders, fetchBlogLimitArtifactBuilders, fetchBlogPostLimitArtifactBuilders, fetchMlangBlogPostLimitArtifactBuilders, fetchBlogListingPagesArtifactBuilders);
export default createRequestStatesReducer(postArtifactBuilderLookup);